import { apiClient } from './client';

export const configApi = {
  getDraft(siteId, env = "prod") {
    return apiClient.get(`/sites/${siteId}/config/draft?env=${encodeURIComponent(env)}`);
  },

  saveDraft(siteId, config, env = "prod") {
    return apiClient.put(`/sites/${siteId}/config/draft?env=${encodeURIComponent(env)}`, { config });
  },

  publish(siteId, notes = "", env = "prod") {
    return apiClient.post(`/sites/${siteId}/config/publish?env=${encodeURIComponent(env)}`, { notes });
  },

  getVersions(siteId, env = "prod") {
    return apiClient.get(`/sites/${siteId}/config/versions?env=${encodeURIComponent(env)}`);
  },

  getVersion(siteId, versionId, env = "prod") {
    return apiClient.get(`/sites/${siteId}/config/versions/${versionId}?env=${encodeURIComponent(env)}`);
  },
};
